import { dataProps, productionCapacityListProps } from './properties'

export const setProductionCapacityList = (state, payload) => {
    state.list = payload
}    

export const setProductionCapacityData = (state, payload) => {
    state.props = payload.response
    
    if(state.props.capacity_list.length === 0) {
        state.props.capacity_list = [JSON.parse(JSON.stringify(productionCapacityListProps))]
    }

} 

export const addNewProductionCapacityItemRow = state => {

    let sl_no = 0
    state.props.capacity_list.push(JSON.parse(JSON.stringify(productionCapacityListProps)))

    state.props.capacity_list.forEach(element => {
        element.sl_no = sl_no
        sl_no ++
    })
}

export const removeProductionCapacityItemRow = (state, payload) => {

    let sl_no = 0

    state.props.deleted_capacity_list_items.push(state.props[payload])

    state.props.capacity_list.splice(payload, 1)

    if(state.props.capacity_list.length === 0) {
        state.props.capacity_list = [JSON.parse(JSON.stringify(productionCapacityListProps))]
    }

    state.props.capacity_list.forEach(element => {
        element.sl_no = sl_no
        sl_no ++
    })

}

export const resetProductionCapacityData = state => {
    state.props = JSON.parse(JSON.stringify(dataProps))
}


// WEBPACK FOOTER //
// ./src/store/modules/productionCapacity/mutations.js